const validation = {
  onlyNumber: { regex: /^[0-9]*$/, msg: 'Invalid format' },
  onlyEngNumber: { regex: /^[a-zA-Z0-9]*$/, msg: 'Invalid format' },
  time: {
    regex: /^[0-9][0-9]:[0-9][0-9]+$/,
    msg: 'Invalid format',
  },
  dateTime: {
    regex: /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))\s[0-9][0-9]:[0-9][0-9]+$/,
    msg: 'Please complete both the date and time.',
  },
  name: { regex: /^.*$/, msg: '格式錯誤' },
  // phone: { regex: /^09\d{8}$/, msg: '格式錯誤' },
  phone: { regex: /^\d{7,11}$/, msg: '格式錯誤' },
  applyName: { regex: /^.*$/, msg: '格式錯誤' },
  // applyPhone: { regex: /^09\d{8}$/, msg: '格式錯誤' },
  applyPhone: { regex: /^\d{7,11}$/, msg: '格式錯誤' },
  calculateType: { regex: /^[a-zA-z]*$/, msg: '' },
  calculateTypeOfMeat: { regex: /^[a-zA-z]*$/, msg: '' },
  calculateTypeOfVegetable: { regex: /^[a-zA-z]*$/, msg: '' },
  numberOfPeople: { regex: /^[0-9]*$/, msg: '格式錯誤' },
  numberOfVegetarian: { regex: /^[0-9]*$/, msg: '格式錯誤' },
};

export default validation;
